import React from "react";
import { Link } from "react-router-dom";
import Service from '../../service/Service';
import * as actions from '../Actions';

const service = new Service();

export default function MoreLeaderboard({ eleRef, leatherDetails }) {
    return (
        // <ul>
            
        <div>
        {leatherDetails && leatherDetails.length > 0 ?
            leatherDetails && leatherDetails.length > 0 && leatherDetails.map((value, index) =>
            // <input type="hidden" id={`record${value.records.count}`} value={record}/>
            <ul key={value.index} >
            {/* <input type="hidden" id={`record${value.records.count}`} value={record}/> */}
            {value.records && value.records.map((result, index)=>
                <li className="participant" key={result.memoryId}>
                    <a href={`/memories/photodetails/${result.memoryId}`} className="parti-img" key={result.index}>
                        <img src={result.imageUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = result.imageUrl.replace("http://", "https://"))} /></a>
                    <div className="like_comment_block M14_white">
                        <span className="like">
                            <span data-icon-font="T" className="like-ic icon"></span>
                            <span id="like-count">{result.likeCount ? result.likeCount : '0'}</span>
                        </span>
                        <span className="comt">
                            <span data-icon-font="e" className="comment-ic icon"></span>
                            <span id="comment-count">{result.commentCount ? result.commentCount : '0'}</span>
                        </span>
                    </div>
                </li>
            )}
            </ul>
            )
            : null
        }
         </div>
        // </ul>
        
    )
}
